module.exports = __webpack_public_path__ + "img/corredor2.874745aa.jpg";